<template>
  <v-menu
    bottom left
    offset-y
    open-on-hover
    :close-on-content-click="false"
    content-class="post-info"
  >
    <v-btn icon flat slot="activator" @mouseenter.native="hover">
      <v-icon>info_outline</v-icon>
    </v-btn>
    <v-list two-line>
      <v-subheader>Автор</v-subheader>
      <v-list-tile
        avatar
      >
        <v-list-tile-avatar>
          <img :src="post.author.photoUrl">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ post.author.name }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ date }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>

import moment from 'moment';

export default {
  name: 'PostInfo',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    date() {
      return moment(this.post.created).format('DD.MM.YYYY HH:mm');
    },
  },
  methods: {
    hover() {
      // this.$ga.page(`${location.pathname}/post-info`);
      this.$ga.event('post-info', 'opened', location.pathname);
    },
  },
};

</script>

<style>

.post-info .subheader {
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/PostInfo.vue